export enum CompaniesEnum {
  SC = 'SC', // Southern Company, no LDC selected
  GA = 'GA',
  FL = 'FL',
  TN = 'TN',
  VA = 'VA'
}

export enum LDCEnum {
  AGLC = 'AGL',
  CGC = 'CGC',
  VNG = 'VNG',
  FCG = 'FCG'
}
